/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Editor_No_ButtonInputs */

const en_editor_no_button = /** @type {(inputs: Editor_No_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No`)
};

const fr_editor_no_button = /** @type {(inputs: Editor_No_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Non`)
};

const de_editor_no_button = /** @type {(inputs: Editor_No_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`NEIN`)
};

const it_editor_no_button = /** @type {(inputs: Editor_No_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`NO`)
};

const ru_editor_no_button = /** @type {(inputs: Editor_No_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Нет`)
};

const es_editor_no_button = /** @type {(inputs: Editor_No_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No`)
};

const zh_cn2_editor_no_button = /** @type {(inputs: Editor_No_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`不`)
};

const ja_editor_no_button = /** @type {(inputs: Editor_No_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`いいえ`)
};

const hi_editor_no_button = /** @type {(inputs: Editor_No_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`नहीं`)
};

const pt_pt2_editor_no_button = /** @type {(inputs: Editor_No_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Não`)
};

/**
* | output |
* | --- |
* | "No" |
*
* @param {Editor_No_ButtonInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const editor_no_button = /** @type {((inputs?: Editor_No_ButtonInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Editor_No_ButtonInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_editor_no_button(inputs)
	if (locale === "de") return de_editor_no_button(inputs)
	if (locale === "it") return it_editor_no_button(inputs)
	if (locale === "ru") return ru_editor_no_button(inputs)
	if (locale === "es") return es_editor_no_button(inputs)
	if (locale === "zh-CN") return zh_cn2_editor_no_button(inputs)
	if (locale === "ja") return ja_editor_no_button(inputs)
	if (locale === "hi") return hi_editor_no_button(inputs)
	if (locale === "pt-PT") return pt_pt2_editor_no_button(inputs)
	return en_editor_no_button(inputs)
});